import { render, staticRenderFns } from "./temp-fee.vue?vue&type=template&id=4f2b9b36&"
import script from "./temp-fee.vue?vue&type=script&lang=js&"
export * from "./temp-fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports